module.exports = __webpack_public_path__ + "static/media/navigation-darker.89175034.png";